export const P0003600CapteurTemperatureEnum = [
  {
    ref: 0,
    label: 'P0003600.installation.prevention.capteurTemperature.0',
    visible: false,
  },
  {
    ref: 1,
    label: 'P0003600.installation.prevention.capteurTemperature.1',
    visible: true,
  },
  {
    ref: 2,
    label: 'P0003600.installation.prevention.capteurTemperature.2',
    visible: true,
  },
];

export const P0003600CapteurTemperatureEnumWithNone = [
  {
    ref: 0,
    label: 'P0003600.installation.prevention.capteurTemperature.0',
    visible: true,
  },
  {
    ref: 1,
    label: 'P0003600.installation.prevention.capteurTemperature.1',
    visible: true,
  },
  {
    ref: 2,
    label: 'P0003600.installation.prevention.capteurTemperature.2',
    visible: true,
  },
];
